import ImagesLayout from "../../Views/Images/Layout";
import Index from "../../Views/Images/Index";
import Pending from "../../Views/Images/Pending";
import Add from "../../Views/Images/Add";

export default [
    {
        path:'/images',
        component:ImagesLayout,
        children:[
            {
                path:'/images',
                component:Index,
                name:'images.index',
            },
            {
                path:'/images/pending',
                component:Pending,
                name:'images.pending.index',
            },
            {
                path:'/images/add',
                component:Add,
                name:'images.add.index',
            },
        ]
    },
];
